<template>
  <div class="InitiativeList">
    <div class="display-flex justify-content-between flex-wrap">
      <div 
        class="cardWrapper"
        v-for="item in cards">
        <initiative-card :item="item"></initiative-card>
      </div>
    </div>
  </div>
</template>
<script>
  const jsonp = require('jsonp')

  import InitiativeCard from './InitiativeCard'
  export default {
    name: "InitiativeList",
    components: {
      InitiativeCard
    },
    data: ()=>{
      return {
        cards: [],
        count: null,
        next: null,
        previous: null
      }
    },
    methods: {
      async loadCards(){
        console.log(this.url)
        jsonp(this.url, null, (err, data) => {
          if (err) {
            throw err.message;
          } else {
            this.cards = data.results
            this.count = data.count
            this.next = data.next
            this.previous = data.previous
          }
        });
      }
    },
    props: {
      url: {
        type: String,
        default: ""
      }
    },
    mounted(){
      try{
        this.loadCards()
      }catch(e){
        console.log(e);
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "~@root/less/func/variables";
  @import "~@root/less/func/elements";
  @import "~@root/less/func/common";
  @import "~@root/less/inc/flex";

  .InitiativeList {
    .cardWrapper{
      flex: 0 1 100%;
      .InitiativeCard{
        display: block;
        margin-bottom: 30px;
        @media (min-width: @bootstrap-md){
          margin-bottom: 80px;
        }
      }
      @media (min-width: @bootstrap-md){
        flex: 0 1 49%;
      }
    }
  }
</style>
